import React from "react";
import { Button } from "react-bootstrap";

const DriverListing = ({
  data,
  type,
  handleAssignDriverModel,
  setAssignModelData,
}) => {
  return (
    <ul className="list-unstyled ps-0 mb-0">
      {data &&
        data[type]?.map((item) => {
          return (
            <li className="d-flex align-items-center border-bottom py-2 justify-content-between gap-10">
              <label htmlFor="" className="form-label themeClr m-0">
                {item.name.charAt(0).toUpperCase() + item?.name?.slice(1)}
              </label>
              {/* <Button
                className="d-flex align-items-center h-auto justify-content-center commonBtn"
                type="button"
                onClick={() => {
                  handleAssignDriverModel();
                  setAssignModelData(item);
                }}
              > 
                Assign
              </Button> */}
            </li>
          );
        })}
    </ul>
  );
};

export default DriverListing;
